<template>
  <footer v-if="section && hasMoreItems">
    <div class="show-more-wrapper">
      <button
        v-if="section.function"
        type="button"
        class="show-more-section-button font-text-2--bold"
        @click="section.function"
      >
        {{ showText }}
      </button>
      <a
        v-else
        :href="section.url"
        class="show-more-section-button font-text-2--bold"
      >
        {{ section.text }}
      </a>
    </div>
  </footer>
</template>

<script>

export default {
  props: {
    sectionName: {
      type: String,
      required: true
    },
    searchInput: {
      type: String,
      default: ""
    },
    initialHits: {
      type: Number,
      default: 0
    },
    totalHits: {
      type: Number,
      default: 0
    },
    documents: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      showErrorText: false,
      sections: {
        ArticleResult: {
          text: 'Visa fler artiklar',
          function: this.loadmore
        },
        FoodSchoolResult: {
          text: 'Visa fler',
          url: `/buffe/sok/#:search=${this.searchInput}&type=foodschool`
        },
        RecipeResult: {
          text: 'Till alla recept',
          url: `/recept/#:search=${this.searchInput}`
        },
        ServicesResult: {
          text: 'Visa fler',
          function: this.loadmore
        },
        StoreResult: {
          text: 'Visa alla butiker',
          url: `/butiker/#:search=${this.searchInput}`
        },
      },
      currentHits: 0
    }
  },
  computed: {
    section () {
     return this.sections[this.sectionName]
    },
    showText () {
      if (this.showErrorText) {
        return "Just nu går det inte att ladda fler. Vänligen försök igen."
      } else {
        return this.section.text
      }
    },
    hasMoreItems () {
      return this.currentHits < this.totalHits
    }
  },
  mounted () {
    this.currentHits = this.initialHits
  },
  methods: {
    loadmore () {
      const sectionNames = {
        ServicesResult: 'services',
        ArticleResult: 'articles'
      }
      const paginationSection = sectionNames[this.sectionName] || ''

      if (this.hasMoreItems) {
        fetch(`${this.$root.envConfig.searchUrl}/api/search/v2/${paginationSection}?query=${this.searchInput}&skip=${this.currentHits}&take=${this.initialHits}`)
            .then(res => {
              if(res.ok) {
                return res.json()
              }
            })
            .then((res) => {
              this.documents.push(...res.Documents)
              this.showErrorText = false
              this.currentHits = this.documents.length
            })
            .catch(() => {
              this.showErrorText = true
            })
      }

    }
  }
}
</script>
<style lang="scss">
.show-more-wrapper {
  cursor: pointer;

  .show-more-section-button {
    display: block;
    padding: 8px;
    line-height: 1;
    text-decoration: none;
    color: $color-secondary-cta-text;
    appearance: none;
    border: none;
    background: transparent;
    width: 100%;
  }
}
</style>
